<template>
  <div class="login">
    <div class="head">
      <img class="girona-logo pb-5" title="Girona FC" src="@/assets/images/logo.jpeg" width="200">
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
            <h5 class="fw-bold lh-base">BENVINGUT/DA A LA CONSULTA <br> PER A LA RENOVACIÓ DE L'ESCUT DEL GIRONA FC</h5>
            <p>Per a participar a la consulta, identifica't amb les teves credencials de Soci</p>
        </div>
        <div class="col-md-3 mx-auto">
          <div v-if="error != ''" class="alert alert-danger">
            {{ error }}
          </div>
          <form>
            <div class="form-group mb-3">
              <input type="text" placeholder="ID" v-model="id" disabled>
            </div>
            <div class="form-group">
              <input type="text" placeholder="PIN" v-model="pin" disabled>
            </div>
            <div class="mt-3 text-center">
              <div class="mt-2">
                <!-- <a style="display: block; line-height: 18px; font-size: 15px; margin-bottom: 8px;" href="https://online.gironafc.cat/index.php/ca-es/recuperar-pin" target="_blank">Consulta el teu pin</a> -->
                <a style="display: block; line-height: 18px; font-size: 15px;" href="https://online.gironafc.cat/index.php/ca-es/altas-socis" target="_blank">Encara no ets soci? Fes-te soci</a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'
import Base64 from 'crypto-js/enc-base64';
import Utf8 from 'crypto-js/enc-utf8'

export default {
  head() {
    return {
      title: 'Login - Girona FC',
      meta: [
        { hid: 'description', name: 'description', content: 'Consulta per a la renovació de l\'escut del Girona FC' },
        { hid: 'robots', name: 'robots', content: 'noindex' }
      ]
    }
  },
  data() {
    return {
      id: "",
      pin: "",
      error: "",
    }
  },
  methods: {
    login() {
      if(this.pin == "" || this.id == "") return false
      let instance = this

      let loader = this.$loading.show();

      let hash = this.id + "_" + CryptoJS.MD5(this.pin)
      let extra = Base64.stringify(CryptoJS.enc.Utf8.parse(this.pin))

      this.$http.get("https://app.gironafcapp.com/apiclient/scripts/api/api.php?format=json&key=54d8e18ba6e4265135cb439484c7f2f8&req=club_auth_girona&hash=" + hash + "&extra=" + extra + "&club=girona&type=1").then((response) => {
        if(response.data.response.result == 'error') {
          instance.error = response.data.response.message
        } else if(response.data.user) {
          this.$cookies.set('member_number', response.data.user.member_number);
          this.$cookies.set('username', response.data.user.profile.name);

          window.username = response.data.user.profile.name
          this.$router.push('/consulta')
        }

        loader.hide()

      })
    }
  },
  mounted() {
    let member_number = this.$cookies.get("member_number");

    if(member_number != null) {
      this.$router.push('/consulta')
    }

  }
}
</script>
